import Vue from 'vue'

Vue.filter('stalkerThreeLetterInitials', username => {
  const parts = username.split(/[ -]/)
  let initials = ''

  if (parts.length > 1) {
    // expecting order of username such as 'last name' and 'first name'
    initials += parts[1].charAt(0)
    initials += parts[0].substr(0, 2)
  } else {
    initials = parts[0]
  }

  initials = initials.substr(0, 3).toUpperCase()

  return initials
})
